import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';

import { ConfigOrcamento } from '../../../../../shared/services/models/vendas/config-orcamento.model';

/**
 * Secao Assinatura [ORC] — os dois campos impressos no fim da proposta.
 *
 * Mesma mecanica da Introducao: a configuracao define o valor padrao e se o vendedor pode
 * altera-lo (`isAssinaturaEditavel`). Os dois campos andam juntos — a configuracao e uma so.
 */
@Component({
    selector: 'app-vd-assinatura',
    standalone: true,
    imports: [ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatIconModule, MatTooltipModule],
    templateUrl: './vd-assinatura.component.html',
    styleUrl: './vd-assinatura.component.css',
})
export class VdAssinaturaComponent {
    @Input({ required: true }) public form!: FormGroup;
    @Input() public configOrcamento: ConfigOrcamento | null = null;
    @Input() public isSomenteLeitura: boolean = false;

    public get isBloqueado(): boolean {
        return this.isSomenteLeitura || this.configOrcamento?.isAssinaturaEditavel === false;
    }
}
